/*
  HDS motion — masked line reveal.
  Lines translate up from behind a mask: 700ms, cubic-bezier(0.22,1,0.36,1),
  60–80ms stagger between lines, plays once at a scroll checkpoint.
  Progressive enhancement: hidden states exist only after JS marks an element
  ready, so failed/absent JS leaves everything visible. Honors reduced motion.
*/
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var HEADINGS =
    '.hds-story__heading, .hds-cta__heading, .hds-process__heading, .hds-band__heading, ' +
    '.collection-list-wrapper .title-wrapper-with-link .title, ' +
    '.collection .title-wrapper-with-link .title, ' +
    '.multicolumn .title';

  var HERO_GROUP = '.hds-hero__overline, .hds-hero__heading, .hds-hero__text, .hds-hero__button';

  // Bir başlığı satır satır maskeye böler. Element alt-etiket içeriyorsa
  // (inline_richtext em/strong) markup'ı bozmamak için tek blok maske kullanılır.
  function splitLines(el) {
    if (el.children.length > 0) {
      wrapWhole(el);
      return;
    }
    var text = el.textContent;
    var words = text.split(/\s+/).filter(Boolean);
    if (words.length === 0) return;

    el.textContent = '';
    var probes = words.map(function (word) {
      var span = document.createElement('span');
      span.textContent = word;
      span.style.display = 'inline-block';
      el.appendChild(span);
      el.appendChild(document.createTextNode(' '));
      return span;
    });

    var lines = [];
    var currentTop = null;
    probes.forEach(function (span) {
      var top = span.offsetTop;
      if (top !== currentTop) {
        lines.push([]);
        currentTop = top;
      }
      lines[lines.length - 1].push(span.textContent);
    });

    el.textContent = '';
    lines.forEach(function (lineWords, i) {
      var mask = document.createElement('span');
      mask.className = 'hds-line-mask';
      var line = document.createElement('span');
      line.className = 'hds-line';
      line.style.transitionDelay = (i * 70) + 'ms';
      line.textContent = lineWords.join(' ');
      mask.appendChild(line);
      el.appendChild(mask);
    });
    el.classList.add('hds-reveal-ready');
  }

  function wrapWhole(el) {
    var mask = document.createElement('span');
    mask.className = 'hds-line-mask';
    var line = document.createElement('span');
    line.className = 'hds-line';
    while (el.firstChild) line.appendChild(el.firstChild);
    mask.appendChild(line);
    el.appendChild(mask);
    el.classList.add('hds-reveal-ready');
  }

  function heroGroup() {
    var items = document.querySelectorAll(HERO_GROUP);
    items.forEach(function (el, i) {
      wrapWhole(el);
      var line = el.querySelector('.hds-line');
      if (line) line.style.transitionDelay = (i * 80) + 'ms';
    });
    return items;
  }

  function init() {
    var targets = [];

    heroGroup().forEach(function (el) { targets.push(el); });
    document.querySelectorAll(HEADINGS).forEach(function (el) {
      splitLines(el);
      targets.push(el);
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach(function (el) {
      if (el.classList.contains('hds-reveal-ready')) observer.observe(el);
    });
  }

  // Smooth scroll — Lenis, tuned not default (lerp 0.1). Touch stays native;
  // overlay scrollers are excluded so drawers and modals keep their own scroll.
  function initScroll() {
    if (typeof window.Lenis !== 'function') return;

    var preventSelectors =
      '.cart-notification, .search-modal, .menu-drawer__inner-container, ' +
      '.drawer__inner, .quick-add-modal__content, [data-cart-drawer]';
    document.querySelectorAll(preventSelectors).forEach(function (el) {
      el.setAttribute('data-lenis-prevent', '');
    });

    var lenis = new window.Lenis({ lerp: 0.1, smoothWheel: true });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }

  function boot() {
    init();
    initScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
